import React,{useState,useEffect} from 'react'
import clinicbookingService from '../../../../../services/clinicbooking.service'
import {toast} from 'react-toastify'
import {useForm} from 'react-hook-form'

function ApptTypeToDocForm({doctor,toogleApptEdit,getDoctorById}) {
   const [docApptType,setDocApptType] = useState([])
   const [apptType,setApptType] = useState([])
    const [isAdd,setIsAdd] = useState(false)

   useEffect(()=>{
        getAllApptType()
        getApptType()

   },[])
   const getApptType = ()=>{
        clinicbookingService.getApptTypeToDoctor(doctor.clinicId,doctor.id,doctor.userId)
        .then(res=>{
            setDocApptType(res.data)
            getDoctorById()
        })
        .catch(err=>{
            console.log(err)
        })
   }
   const getAllApptType = ()=>{
    clinicbookingService.getAllApptType(doctor.clinicId)
    .then(res=>{
        setApptType(res.data)
    })
    .catch(err=>{
        console.log(err)
    })
   }
   const handleDelete = (appt)=>{
        const apptData = [appt.appointmentTypeId]
      
        clinicbookingService.deleteApptTypeToDoctor(appt.clinicId,appt.doctorId,appt.userId,apptData)
        .then(res=>{
            getApptType()
        })
        .catch(err=>{
            console.log(err)
        })
   }
   const handleAdd = (appt)=>{
        const newAppt = [appt.id]
        clinicbookingService.addUpdateApptTypeToDoctor(appt.clinicId,doctor.id,doctor.userId,newAppt)
        .then(res=>{
            toast.success("Added Appointment Type",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
            getApptType()
        })
        .catch(err=>{
            console.log(err)
        })
   }
   const inApptList = (id)=>{
        let retVal = false
        docApptType.forEach((appt)=>{
            if(appt.appointmentTypeId === id)
                retVal=true;            
        })
        return retVal
   }
   const toogleAdd = ()=>{
    setIsAdd(!isAdd)
   }
   return (
    <>
        <div className="card">
            <div className="card-body">
                <div className="d-flex justify-content-end">
                    <button className="btn btn-sm btn-secondary mt-3" onClick={toogleApptEdit}><i className="bi bi-x-square"></i> Close</button>
                </div>
                <ul className='list-group m-3'>
                    {docApptType && docApptType.map((docAppt)=>{
                        return (
                            <li className="list-group-item d-flex justify-content-between align-items-center" key={docAppt.id}>
                                    <div className="m-2">
                                       {docAppt.apptType} ({docAppt.timeSlot} minutes)
                                    </div>
                                    <button className="btn btn-sm btn-warning" onClick={()=>handleDelete(docAppt)}><i className="bi bi-trash"></i></button>
                            </li>
                        )
                    })}
                </ul>
                {isAdd ? 
                <div className="row">
                    <div className="col">
                        <h4>Add From the List below</h4>
                        <ul className="list-group">

                       
                        {apptType && apptType.map((appointment)=>{
                            
                           
                                return <li key={appointment.id} className='list-group-item d-flex justify-content-between align-item-center'>
                                        <div className="m-1">
                                            {appointment.apptType} ({appointment.timeSlot} minutes)
                                        </div>
                                        {inApptList(appointment.id)? "": <button className="btn btn-sm btn-success" onClick={()=>handleAdd(appointment)}>Add</button>}
                                        
                                       
                                </li>
                        })}
                         </ul>
                    </div>
                </div>
                : ""}
               <div className="row m-3">
                <div className="col">
                    {isAdd ?   <button className="btn btn-sm btn-secondary" onClick={toogleAdd}><i className="bi bi-x-square"></i> Cancel</button>:<button className="btn btn-sm btn-success ms-3 me-3" onClick={toogleAdd}><i className="bi bi-plus-square"></i> Add Appointment Type</button>}
                  
                </div>
               </div>
            </div>
        </div>
    </>
  )
}


export default ApptTypeToDocForm